import { useLocation, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';

export default function Header() {
  const [pageState, setPageState] = useState('Sign in');
  const location = useLocation();
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setPageState('Profile');
      } else {
        setPageState('Sign in');
      }
    });
  }, [auth]);

  function pathMatchRoute(route) {
    if (route === location.pathname) {
      return true;
    }
  }

  return (
    <div className="bg-white border-b shadow-sm sticky top-0 z-40">
      <header className="flex justify-between items-center px-3 max-w-6xl mx-auto py-3">
        {/* Logo Section - Vertical Layout */}
        <div
          className="flex flex-col items-center cursor-pointer group"
          onClick={() => navigate('/')}
        >
          {/* Circular P&M Logo Image */}
          <img
            src="/logo.png"
            alt="P&M Dream Manors Logo"
            className="w-16 h-16 sm:w-20 sm:h-20 object-contain transition-transform duration-300 group-hover:scale-105"
          />
          
          {/* Company Name Below Logo - Desktop */}
          <div className="mt-2 bg-[#1e3a8a] px-4 py-1.5 rounded-md hidden lg:block transition-all duration-300 group-hover:bg-[#2563eb] group-hover:shadow-md">
            <h1 className="text-white font-bold text-xs tracking-[0.15em] whitespace-nowrap">
              DREAM MANORS PRIVATE LIMITED
            </h1>
          </div>

          {/* Company Name Below Logo - Tablet */}
          <div className="mt-2 bg-[#1e3a8a] px-3 py-1 rounded-md hidden sm:block lg:hidden transition-all duration-300 group-hover:bg-[#2563eb]">
            <h1 className="text-white font-bold text-[10px] tracking-wider whitespace-nowrap">
              DREAM MANORS PVT LTD
            </h1>
          </div>

          {/* Company Name Below Logo - Mobile */}
          <div className="mt-1.5 bg-[#1e3a8a] px-2 py-1 rounded sm:hidden transition-all duration-300 group-hover:bg-[#2563eb]">
            <h1 className="text-white font-bold text-[9px] tracking-wide whitespace-nowrap">
              P&M DREAM MANORS
            </h1>
          </div>
        </div>

        {/* Navigation Menu */}
        <div>
          <ul className="flex space-x-4 sm:space-x-6 lg:space-x-10">
            <li
              className={`cursor-pointer py-3 text-xs sm:text-sm font-semibold border-b-[3px] border-b-transparent transition-all duration-200 ${
                pathMatchRoute('/') 
                  ? 'text-[#1e3a8a] border-b-[#1e3a8a]' 
                  : 'text-gray-400 hover:text-gray-700'
              }`}
              onClick={() => navigate('/')}
            >
              Home
            </li>
            <li
              className={`cursor-pointer py-3 text-xs sm:text-sm font-semibold border-b-[3px] border-b-transparent transition-all duration-200 ${
                pathMatchRoute('/offers') 
                  ? 'text-[#1e3a8a] border-b-[#1e3a8a]' 
                  : 'text-gray-400 hover:text-gray-700'
              }`}
              onClick={() => navigate('/offers')}
            >
              Offers
            </li>
            <li
              className={`cursor-pointer py-3 text-xs sm:text-sm font-semibold border-b-[3px] border-b-transparent transition-all duration-200 hidden sm:block ${
                pathMatchRoute('/about') 
                  ? 'text-[#1e3a8a] border-b-[#1e3a8a]' 
                  : 'text-gray-400 hover:text-gray-700'
              }`}
              onClick={() => navigate('/about')}
            >
              About
            </li>
            <li
              className={`cursor-pointer py-3 text-xs sm:text-sm font-semibold border-b-[3px] border-b-transparent transition-all duration-200 hidden sm:block ${
                pathMatchRoute('/contact') 
                  ? 'text-[#1e3a8a] border-b-[#1e3a8a]' 
                  : 'text-gray-400 hover:text-gray-700'
              }`}
              onClick={() => navigate('/contact')}
            >
              Contact
            </li>
            <li
              className={`cursor-pointer py-3 text-xs sm:text-sm font-semibold border-b-[3px] border-b-transparent transition-all duration-200 ${
                (pathMatchRoute('/sign-in') || pathMatchRoute('/profile'))
                  ? 'text-[#1e3a8a] border-b-[#1e3a8a]' 
                  : 'text-gray-400 hover:text-gray-700'
              }`}
              onClick={() => navigate('/profile')}
            >
              {pageState}
            </li>
          </ul>
        </div>
      </header>
    </div>
  );
}
